<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead v-if="!loadingApplications && applications.length">
                    <tr>
                        <th>{{$t('dashboard.applications.table.header.date')}}</th>
                        <th>{{$t('dashboard.applications.table.header.vacancy')}}</th>
                        <th>{{$t('dashboard.applications.table.header.company')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingApplications" :key="'loading'" class="table--loading">
                        <td colspan="6">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('dashboard.applications.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingApplications && !applications.length" :key="'no-applications'" class="table--empty">
                        <td colspan="6">
                            <div class="text-center">{{$t('dashboard.applications.table.no_applications')}}</div>
                        </td>
                    </tr>
                    <template v-if="applications.length">
                        <tr v-for="application in applications" :key="application.id">
                            <td>{{ application.date | formatDate }}</td>
                            <td style="max-width: 4rem;">{{ application.vacancy }}</td>
                            <td>{{ application.company }}</td>
                            <td>
                                <span v-if="!application.readonly"
                                    @click="showAttachments(application)"
                                    v-tooltip.bottom="$tc('dashboard.applications.table.attachments', application.files.length, { count: application.files.length })"
                                    class="table__icon icons icon-paper-clip">
                                </span>
                            </td>
                            <td>
                                <span v-if="!application.readonly"
                                    @click="editApplication(application)"
                                    v-tooltip.bottom="$t('dashboard.applications.table.edit')"
                                    class="table__icon icons icon-pencil">
                                </span>
                            </td>
                            <td>
                                <span v-if="!application.readonly"
                                    @click="showDeleteApplicationModal(application)"
                                    v-tooltip.bottom="$t('dashboard.applications.table.delete')"
                                    class="table__icon icons icon-trash">
                                </span>
                            </td>
                        </tr>
                    </template>
                    <tr class="table__navigation" v-if="applicationsMeta && applicationsMeta.last_page > 1">
                        <td colspan="6">
                            <pagination :meta="applicationsMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { saveFile } from '@/helpers';
    import Pagination from '@/components/tables/Pagination';
    import { GET_APPLICATIONS } from '@/store/modules/applications';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class ApplicationsTable extends Vue {
        name = 'applications-table';

        created() {
            this.$store.dispatch(GET_APPLICATIONS, {});
        }

        get applications() {
            return this.$store.state.applications.applications;
        }

        get loadingApplications() {
            return this.$store.state.applications.loading;
        }

        get applicationsMeta() {
            return this.$store.state.applications.applicationsMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_APPLICATIONS, { params: { page: pageNo }});
        }

        showAttachments(application) {
            this.$modal.show('application-attachments-modal', { application });
        }

        editApplication(application) {
            this.$modal.show('application-modal', { application });
        }

        showDeleteApplicationModal(application) {
            const content = {
                title: this.$t('modals.delete_application.title'),
                message: this.$t('modals.delete_application.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteApplication, application});
        }

        deleteApplication({application}) {
            application.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.application.delete_success'));
                    this.$store.dispatch(GET_APPLICATIONS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.application.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/ApplicationsTable.vue